import { render, staticRenderFns } from "./RedirectToLastRouteModal.vue?vue&type=template&id=4dd0f6e8"
import script from "./RedirectToLastRouteModal.vue?vue&type=script&lang=js"
export * from "./RedirectToLastRouteModal.vue?vue&type=script&lang=js"
import style0 from "./RedirectToLastRouteModal.vue?vue&type=style&index=0&id=4dd0f6e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports